module.exports = "<div class=\"row\">\n  <div class=\"col-xs-12 col-sm-6\">\n    <div class=\"question-text\" [innerHtml]=\"textQuestionPrompt.value | mpSafeHtml\"></div>\n  </div>\n  <div class=\"col-xs-12 col-sm-6\">\n    <mp-hide-show-choice-view (optionSelected)=\"onOptionSelected($event)\"\n      [answerChoicePrompt]=\"firstAnswerChoicePrompt\"\n      [formGroup]=\"firstAnswerChoiceFormGroup\"\n    >\n    </mp-hide-show-choice-view>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/question-view/flash-card-question-view/flash-card-question-view.html
// module id = l5mp
// module chunks = 3